const COOKIES = {
  visitor: 'KmxVisitor_0',
};
export default {
  MAX_MONTHLY_PAYMENT: 'MaxMonthlyPayment',
  SHIPPING: 'Shipping',
  MAX_CONDITIONED_AMOUNT: 'MaxConditionedAmount',
  MY_KMX_USER: 'MyKmxUser',
  GetCookieAllInfo(cookieName: string) {
    const result: { Name: string; Value: string }[] = [];
    const cookie = document.cookie
      .split(';')
      .filter((item) => item.includes(`${cookieName}=`));
    cookie?.[0]
      ?.trim()
      .replace(`${cookieName}=`, '')
      .split('&')
      .forEach((item) => {
        const cookieItem = item.split('=');
        result.push({ Name: cookieItem[0], Value: cookieItem[1] });
      });
    return result;
  },
  GetCookieItemValue(key: string, cookie = COOKIES.visitor) {
    const cookieData = this.GetCookieAllInfo(cookie);
    const cookieStoreId = cookieData.filter((item) => item.Name === key);
    if (cookieStoreId.length > 0) {
      return cookieStoreId[0].Value;
    }
    return null;
  },
};
